module.exports = __webpack_public_path__ + "static/media/home-02.30319c37.webm";